import { Component, computed, inject, PLATFORM_ID, signal } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { ConsentService } from '../../services/consent.service';

@Component({
  selector: 'app-cookie-banner',
  standalone: true,
  imports: [CommonModule, RouterLink, FormsModule, ToggleSwitchModule],
  templateUrl: './cookie-banner.component.html',
  styleUrl: './cookie-banner.component.scss',
})
export class CookieBannerComponent {
  private readonly consent = inject(ConsentService);

  /**
   * Server rendert den Banner nie (Cookie wird im SSR-Pfad nicht gelesen →
   * needsDecision wäre serverseitig immer true). Erst der Client entscheidet
   * anhand des Cookies — verhindert Hydration-Mismatch/Flicker.
   */
  readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
  readonly visible = computed(() => this.isBrowser && this.consent.needsDecision());

  readonly showSettings = signal(false);
  /** Default AUS — nichts vorausgewählt (TDDDG: keine Vorab-Häkchen). */
  readonly analytics = signal(false);

  acceptAll(): void {
    this.consent.acceptAll();
  }

  rejectAll(): void {
    this.consent.rejectAll();
  }

  saveSelection(): void {
    this.consent.save({ analytics: this.analytics(), marketing: false });
  }

  toggleSettings(): void {
    this.showSettings.update((v) => !v);
  }
}
